<div class="outerContainer">
<div class="strandsSummary" *ngIf="courseSummaries">
    <div>
        <span class="detail-name">Pathways time spent</span>
        {{ displayTimeWithoutSeconds(getPathwaysTimeSpent()) }}
    </div>
    <div *ngIf="currentStrandSummary && currentStrandSummary.LastStartedActivity">
        <span class="ml-4 detail-name">Most Recent Activity</span>
        {{ longDateFormat(getPathwaysLastActivity()) }}
    </div>
    <div *ngIf="!(currentStrandSummary && currentStrandSummary.LastStartedActivity)">
        <span class="ml-4 detail-name">Most Recent Activity</span>
        No Activity
    </div>
</div>
<div class="strandsTitle">LEARNING STRANDS</div>
<div class="strandTabs">
    <div class="strandTab" [ngClass]="currentStrand == 'P-OralLanguage' ? 'activeTab' : 'inactiveTab'" (click)="onTabClicked('P-OralLanguage')">Oral Language</div>
    <div class="tabSpacer"></div>
    <div class="strandTab" [ngClass]="currentStrand == 'P-Literacy' ? 'activeTab' : 'inactiveTab'" (click)="onTabClicked('P-Literacy')">Literacy</div>
    <div class="tabSpacer"></div>
    <div class="strandTab" [ngClass]="currentStrand == 'P-Conversations' ? 'activeTab' : 'inactiveTab'" (click)="onTabClicked('P-Conversations')">Conversation</div>
    <div class="tabSpacer"></div>
    <div class="strandTab" [ngClass]="currentStrand == 'P-Values' ? 'activeTab' : 'inactiveTab'" (click)="onTabClicked('P-Values')">Values</div>
    <div class="tabSpacerEnd"></div>
</div>
<app-student-progress-report-strand [strand]="currentStrandSummary" [studentId]="studentId"></app-student-progress-report-strand>
</div>
